import React from 'react';
import './ErrorScreen.css'
import DotGrid from '../Components/Layout/DotGrid'
import ErrorIcon from '../Assets/Error.svg'
import Btn from '../Components/Common/Btn';

const ErrorScreen = () => {
    return ( 
        <div className='Error404'>

            <div style={{ width: '100%', height: '100vh', position: 'absolute', boxSizing: 'border-box', zIndex: '-1' }}>
                <DotGrid
                    dotSize={5}
                    gap={15}
                    baseColor="#311010"
                    activeColor="#ff4f4f"
                    proximity={120}
                    shockRadius={250}
                    shockStrength={5}
                    resistance={750}
                    returnDuration={1.5}
                />
                </div>

            <div className='ErrorMsg2'>
                <img src={ErrorIcon} alt="" />
                <p className='MsgTitle'>404</p>
                <p className='MsgDesc'>
                    PAGE NOT FOUND
                </p>
            </div>

            <Btn BtnStyle="BackBtn" BtnText="Go Back Home"/>
        </div>
     );
}
 
export default ErrorScreen;